module.exports = __webpack_public_path__ + "static/media/AWS_Logo.f3f38fee.svg";